'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Small } from 'foundations-components/transitional/components/Small';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LEARN_MORE_URL = 'https://blog.hubspot.com/marketing/am-guide-accelerated-mobile-pages';
class PublishingAmpEnabler extends Component {
  render() {
    const {
      ampEnabled,
      contentGroupId,
      contentType,
      disabled,
      onToggleAmpEnabled,
      shouldShow
    } = this.props;
    const editUrl = contentGroupId ? ContentRoutes.blogSpecificSettings(contentGroupId) : ContentRoutes.settings('blog');
    if (shouldShow) {
      return /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publishingOptions.amp.heading"
          }),
          children: /*#__PURE__*/_jsxs(Checkbox, {
            checked: ampEnabled,
            onChange: onToggleAmpEnabled,
            readOnly: disabled,
            marginBlockStart: "400",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `publishingOptions.amp.checkbox.${contentType}`
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Small, {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "publishingOptions.amp.description"
              }), "\xA0", /*#__PURE__*/_jsx(Link, {
                href: LEARN_MORE_URL,
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "publishingOptions.amp.learnMore"
                })
              }), "."]
            })]
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          width: "150px",
          children: /*#__PURE__*/_jsx(Button, {
            href: editUrl,
            block: true,
            use: "tertiary-light",
            size: "small",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "publishingOptions.amp.manage"
            })
          })
        })]
      });
    }
    return null;
  }
}
PublishingAmpEnabler.propTypes = {
  ampEnabled: PropTypes.bool.isRequired,
  contentGroupId: PropTypes.number,
  contentType: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onToggleAmpEnabled: PropTypes.func.isRequired,
  shouldShow: PropTypes.bool.isRequired
};
PublishingAmpEnabler.defaultProps = {
  ampEnabled: false
};
export default PublishingAmpEnabler;